export const communityDemoScript = [
  {
    id: 'scene-1-sidebar',
    audioUrl: '/audio/demo/community/scene-1.mp3',
    actions: [
      { type: 'select-first-real-channel', afterMs: 900 },
    ],
  },
  {
    id: 'scene-2-edit-channel',
    audioUrl: '/audio/demo/community/scene-2.mp3',
    actions: [
      {
        type: 'emit',
        name: 'community:tour-open-edit-channel',
        detail: { mode: 'demo', channel: 'first-editable' },
        afterMs: 900,
      },
      {
        type: 'highlight',
        selector: '#channel-name',
        label: 'Aquí puedes cambiar el nombre del canal',
        afterMs: 800,
      },
      { type: 'input', selector: '#channel-name', value: 'Canal Premium Demo', afterMs: 400 },
      {
        type: 'clear-highlight',
        afterMs: 200,
      },
    ],
  },
  {
    id: 'scene-3-chat-panel',
    audioUrl: '/audio/demo/community/scene-3.mp3',
    actions: [
      { type: 'wait', ms: 700 },
    ],
  },
  {
    id: 'scene-4-room-settings',
    audioUrl: '/audio/demo/community/scene-4.mp3',
    actions: [
      {
        type: 'emit',
        name: 'community:tour-open-channel-settings',
        detail: { mode: 'demo' },
        afterMs: 1200,
      },
      {
        type: 'highlight',
        selector: '[data-tour="community-settings-panel"]',
        label: 'Desde aquí controlas la configuración del grupo',
        afterMs: 1200,
      },
    ],
  },
  {
    id: 'scene-5-members-tab',
    audioUrl: '/audio/demo/community/scene-5.mp3',
    actions: [
      {
        type: 'emit',
        name: 'community:tour-open-members-drawer',
        detail: { mode: 'demo' },
        afterMs: 1000,
      },
    ],
  },
  {
    id: 'scene-6-open-post',
    audioUrl: '/audio/demo/community/scene-6.mp3',
    actions: [
      {
        type: 'emit',
        name: 'community:tour-open-post-edit',
        detail: { mode: 'demo', demo: true, post: 'first-editable' },
        afterMs: 1200,
      },
      { type: 'click', selector: '[data-demo="post-actions-trigger"]', afterMs: 700, required: false },
      { type: 'click', selector: '[data-tour="post-edit-button"]', afterMs: 1000, required: false },
    ],
  },
  {
    id: 'scene-7-change-post-channel',
    audioUrl: '/audio/demo/community/scene-7.mp3',
    actions: [
      { type: 'click', selector: '[data-tour="post-channel-select"]', afterMs: 900, required: false },
    ],
  },
  {
    id: 'scene-8-outro',
    audioUrl: '/audio/demo/community/outro.mp3',
    actions: [
      { type: 'wait', ms: 300 },
    ],
  },
]